import { Component, ViewEncapsulation } from '@angular/core';
import { NbCalendarRange, NbRangepickerComponent } from '@nebular/theme';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DialogService } from '../../../service/dialog.service';
import { Dates } from '../../../util/dates';
import { Objects } from '../../../util/objects';
import { RangePickerComponent } from '../../calander/range-picker.component';

@Component({
  selector: 'ngx-period-column',
  template: `
  <div class="d-flex align-items-center justify-content-center">
    {{ params.getValue() }}
    <nb-icon icon="calendar-outline" class="pointer ml-2" (click)="openCalander()"></nb-icon>
    <nb-icon *ngIf="range.start && range.end" icon="close-outline" class="pointer ml-2" (click)="reset()"></nb-icon>
  </div>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class PeriodColumnComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public label: string = "";
  public range: NbCalendarRange<Date>;

  private displayAttr: string = "periods";
  private startDateAttr: string = "startDate";
  private endDateAttr: string = "endDate";

  private prevValue: any = {
    startDate: null, endDate: null
  }

  constructor(private dialogService: DialogService) {}

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.displayAttr = Objects.safeGetValue(this.params, 'displayAttr', "periods");
    this.label = Objects.safeGetValue(this.params.data, this.displayAttr, "");
    this.startDateAttr = Objects.safeGetValue(this.params, "startDate", "startDate");
    this.endDateAttr = Objects.safeGetValue(this.params, "endDate", "endDate");
    this.prevValue.startDate = Objects.safeGetValue(this.params.data, this.startDateAttr, null);
    this.prevValue.endDate = Objects.safeGetValue(this.params.data, this.endDateAttr, null);
    this.range = {
      start: this.prevValue.startDate ? Objects.copy(this.prevValue.startDate) : null,
      end: this.prevValue.endDate ? Objects.copy(this.prevValue.endDate) : null
    };
  }

  ngOnInit() {
  }

  onClick() {
    this.params.context.showMore(this.params.data);
  }

  openCalander() {
    const pop = this.dialogService.open(RangePickerComponent, { closeOnBackdropClick: false });

    pop.onClose.subscribe(res => {

      if (!res || res.length === 0) {
        return;
      }

      this.params.data[this.startDateAttr] = this.range.start = Dates.morning(res.start);
      this.params.data[this.endDateAttr] = this.range.end = Dates.night(res.end);

    });
  }

  reset() {
    this.params.data[this.startDateAttr] = this.range.start = null;
    this.params.data[this.endDateAttr] = this.range.end = null;
  }
  
}
